import axios from "../../index";
import api from "./blocks.api";

export default {
  /**
   * 获取积木列表
   */
  getBlockList(data = {}) {
    return axios.post(api.getBlockList, data);
  },
   /**
   * 获取编辑器的部分积木列表---我的模型、公共模型部分
   */
    getModelBlockList(data = {}) {
    return axios.post(api.getModelBlockList, data);
  },
  
  /**
   * 查询媒体积木  @data projectId 项目id
   */
  getMediaByTrainingId(data = {}) {
    return axios.post(api.getMediaByTrainingId, data);
  },
  /**
   * 新增媒体积木  @data mediaFileName 媒体名称  mediaFileUrl 媒体文件url projectId 项目id
   */
  insertMedia(data = {}) {
    return axios.post(api.insertMedia, data);
  },
  /**
   * 修改媒体积木  @data mediaFileName 媒体名称  mediaFileUrl 媒体文件url 
   */
  updateMedia(data = {}) {
    return axios.post(api.updateMedia, data);
  },
  /**
   * 删除媒体积木  @data mediaFileName 媒体名称  mediaFileUrl 媒体文件url 
   */
  deleteMedia(data = {}) {
    return axios.post(api.deleteMedia, data);
  },
  
};
